import { arrayHas } from "../arrayHas.js";
//#region src/utils/collection/sequence.ts
function addAndSort(ids, seqIds, id) {
	if (arrayHas(seqIds)(id)) {
		const idIndices = seqIds.reduce((acc, cur, index) => {
			acc[cur] = index;
			return acc;
		}, {});
		ids.push(id);
		ids.sort((a, b) => {
			const indexA = idIndices[a];
			const indexB = idIndices[b];
			return indexA === void 0 ? 1 : indexB === void 0 ? -1 : indexA - indexB;
		});
	} else {
		ids.push(id);
		seqIds.push(id);
	}
}
//#endregion
export { addAndSort };
